import { Collection } from '../../models/Collection';
import { rModelsBase } from './.catalog';

export interface rOyakKiraBilgileri {
  toplam: number;
  tasinmaz_adi: string;
  kiraci_adi: string;
  il: string;
}

export default class rOyakKiraBilgileriYillarWrapper extends rModelsBase {
  constructor(
    options1?: {
      KiraBilgileri: rOyakKiraBilgileri[];
      AnahtarTuru: string;
      DegerTuru: string;
      Yillar: number[];
    },
    options2?: rOyakKiraBilgileriYillarWrapper
  ) {
    super();
    this.KiraBilgileri = options1?.KiraBilgileri || options2?.KiraBilgileri;
    this.AnahtarTuru = options1?.AnahtarTuru || options2?.AnahtarTuru;
    this.DegerTuru = options1?.DegerTuru || options2?.DegerTuru;
    this.Yillar = options1?.Yillar || options2?.Yillar;
  }

  public KiraBilgileri: rOyakKiraBilgileri[] | undefined;
  public Yillar: number[] | undefined;
  public AnahtarTuru: string | undefined;
  public DegerTuru: string | undefined;
}
